import axiosInstance from "./apiinterseptor"; 
import { toast } from "react-hot-toast"; 
import axios, { AxiosError } from 'axios';
import * as XLSX from "xlsx";

export const userLoginWithOtp = async ({ emailorphone, otp }: { emailorphone: string; otp: string }) => {
    try {
        const response = await axiosInstance.post(`/auth/portal/login-otp`, { emailorphone, otp });
        if (response.status !== 200) throw Error(response.data?.message);
        const accessToken = response.data?.accessToken;
        if (accessToken) {
            localStorage.setItem('accessToken', accessToken);
            axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
        }
        return response.data;
    } catch (error: any) {
        const msg = error.response?.data?.message || error.message;
        toast.error(`Login failed. ${msg}`);
        throw error;
    }
};

export const userLogin = async ({ email, password }: { email: string; password: string }) => {
    try {
        const response = await axiosInstance.post(`/auth/portal/login`, { email, password });
        if (response.status!==200) {
            throw Error(response.data.message);
        }
        console.log("Login response data:", response);
        
        const accessToken = response.data.accessToken ; 
        
        if (accessToken) {
            localStorage.setItem('accessToken', accessToken);
            
            axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
            
            console.log('🔐 Token stored successfully:', accessToken.substring(0, 20) + '...');
        } else {
            console.error('🔐 No access token received in login response');
        }
        
        return response.data;
    } catch (error: any) {
        console.error("Login failed:", error.response?.data?.message);
        if (error.response?.data?.message === 'Account is deactivated') {
            toast.error(`Login failed. This ${error.response.data.message} by admin.`);
            throw new Error('Account is deactivated.');
        } else {
            toast.error(`Login failed. ${error.response?.data?.message}.`);
        }
        throw error;
    }
};
  
export const sendotp = async (emailorphone: string) => {
  
    try {
        const response = await axiosInstance.post('/users/send-otp', { emailorphone: emailorphone });
        console.log("OTP sent successfully:", response.data);
        toast.success("OTP sent successfully");
        return response.data;
    } catch (error: any) {
        console.error("Failed to send OTP:", error.response?.data?.message);
        toast.error(`Failed to send OTP: ${error.response?.data?.message || 'Unknown error'}`);
        throw error;
    }
}
export const verifyotp = async (emailorphone: string , otp: string) => {
  
    try {
        const response = await axiosInstance.post('/users/verify-otp', { emailorphone, otp });
        console.log("otp verified", response.data);
        toast.success("OTP verified successfully");
        return response.data;
    } catch (error: any) {
        console.error("Failed to send OTP:", error.response?.data?.message);
        toast.error(`Failed to send OTP: ${error.response?.data?.message || 'Unknown error'}`);
        throw error;
    }
}
export const forgetPassword = async (password: string,passwordConfirm: string,emailorphone: string) => {
    try {
        const response = await axiosInstance.post('/users/forget-password', { password, passwordConfirm,emailorphone});
        console.log("Password reset successfully:", response.data);
        toast.success("Password reset successfully");
        return response.data;
    } catch (error: any) {
        console.error("Failed to reset password:", error.response?.data?.message);
        toast.error(`Failed to reset password: ${error.response?.data?.message || 'Unknown error'}`);
        throw error;
    }
}

export const isUserLoggedIn = async () => {
    try {
        const response = await axiosInstance.get('/auth/is-logged-in');
        return response.data;
    } catch (error) {
        console.error("Check login status failed:", error);
        throw error;
    }
};


// Add these missing authentication APIs:

// 1. Portal User Registration (Admin only)
export const registerPortalUser = async (userData: {
  username: string;
  email: string;
  phone: string;
  password: string;
  // role: string;
  location: string;
  // assignedManagerUserId?: string;
}) => {
  try {
    const response = await axiosInstance.post('/auth/portal/register', userData);
    console.log("Portal user registered successfully:", response.data);
    toast.success("Portal user registered successfully");
    return response.data;
  } catch (error: any) {
    console.error("Failed to register portal user:", error.response?.data?.message);
    toast.error(`Failed to register portal user: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

export const registerInvestorPortalUser = async (userData: {
  username: string;
  email: string;
  phone: string;
  password: string;
  location: string;
  otp: string;
}) => {
  try {
    const response = await axiosInstance.post('/auth/portal/register-investor', userData);
    const accessToken = response.data?.accessToken as string | undefined;
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
    }
    toast.success("Account created. You're signed in.");
    return response.data;
  } catch (error: any) {
    console.error("Failed to register investor:", error.response?.data?.message);
    toast.error(`Failed to register investor: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

export const sendPortalRegistrationOtp = async (emailorphone: string) => {
  try {
    const response = await axiosInstance.post('/auth/portal/register/send-otp', { emailorphone });
    return response.data;
  } catch (error: any) {
    toast.error(error.response?.data?.message || "Failed to send OTP");
    throw error;
  }
};

export const verifyPortalRegistrationOtp = async (emailorphone: string, otp: string) => {
  try {
    const response = await axiosInstance.post('/auth/portal/register/verify-otp', { emailorphone, otp });
    return response.data;
  } catch (error: any) {
    toast.error(error.response?.data?.message || "Invalid OTP");
    throw error;
  }
};


export const registerPortalUserTpo = async (userData: {
  username: string;
  email: string;
  phone: string;
  password: string;
  // role: string;
  location: string;
  // assignedManagerUserId?: string;
}) => {
  try {
    const response = await axiosInstance.post('/auth/portal/register-tpo', userData);
    console.log("TPO user registered successfully:", response.data);
    toast.success("TPO user registered successfully");
    return response.data;
  } catch (error: any) {
    console.error("Failed to register TPO user:", error.response?.data?.message);
    toast.error(`Failed to register TPO user: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

// 2. Candidate Registration
export const registerCandidate = async (candidateData: {
  email: string;
  password: string;
  passwordConfirm: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
}) => {
  try {
    const response = await axiosInstance.post('/auth/candidate/register', candidateData);
    console.log("Candidate registered successfully:", response.data);
    toast.success("Candidate registered successfully");
    return response.data;
  } catch (error: any) {
    console.error("Failed to register candidate:", error.response?.data?.message);
    toast.error(`Failed to register candidate: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};



// 3. Candidate Login
export const candidateLogin = async ({ email, password }: { email: string; password: string }) => {
  try {
    const response = await axiosInstance.post('/auth/candidate/login', { email, password });
    console.log("Candidate login successful:", response.data);
    
    // Handle token storage similar to userLogin
    const accessToken = response.data.accessToken || response.data.token;
    
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('authToken', accessToken);
      
      // Update axios instance headers
      axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
      console.log('🔐 Candidate token stored successfully');
    }
    
    toast.success("Candidate login successful");
    return response.data;
  } catch (error: any) {
    console.error("Candidate login failed:", error.response?.data?.message);
    toast.error(`Candidate login failed: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

// 4. Get Current User Details
export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get('/auth/me');
    console.log("Current user details fetched:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch current user:", error.response?.data?.message);
    // Don't show toast for this as it might be called frequently in auth contexts
    throw error;
  }
};



// 5. Enhanced logout function that clears all storage
export const logoutUser = async () => {
  try {
    await axiosInstance.post('/auth/logout');
    
    // Clear all stored tokens
    localStorage.removeItem('accessToken');
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
    
    // Clear axios headers
    delete axiosInstance.defaults.headers.Authorization;
    
    toast.success("Logged out successfully");
    return { success: true };
  } catch (error: any) {
    console.error("Logout failed:", error.response?.data?.message);
    // Still clear tokens even if API call fails
    localStorage.removeItem('accessToken');
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
    delete axiosInstance.defaults.headers.Authorization;
    
    toast.error(`Logout failed: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};
export const editAssessment = async (assessmentData: any, assessmentId: string) => {
  try {
    const response = await axiosInstance.put(
      `${assessmentURL}/admin/editAssessment/${assessmentId}`,
      assessmentData
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};

export const getAccessToken = (): string | undefined => {
  return localStorage.getItem('accessToken') ?? undefined;
};

export const getAssignableUsers=async (jobId: string) => {
  try {
    const response = await axiosInstance.get(`/jobs/${jobId}/assignable-users`);
    console.log("Current user details fetched:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch current user:", error.response?.data?.message);
    // Don't show toast for this as it might be called frequently in auth contexts
    throw error;
  }
};


export const assignUsers=async (data: any,jobId: string) => {
  try {
    const response = await axiosInstance.post(`/jobs/${jobId}/assign`,data);
    console.log("Current user details fetched:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch current user:", error.response?.data?.message);
    // Don't show toast for this as it might be called frequently in auth contexts
    throw error;
  }
};

export const getAssignedManagers = async (role: string, search?: string) => {
  try {
    let url = `/users?role=${role}&page=1&limit=25`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    const response = await axiosInstance.get(url);
    if(response.status !== 200){
      throw new Error('Failed to fetch users');
    }
    return response.data.data.users;
  }
  catch (error: any) {
    console.error("Failed to fetch users:", error.response?.data?.message);
    toast.error(`Failed to fetch users: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
  
  
}
const assessmentURL= process.env.REACT_APP_ASSESSMENT_API_URL;
console.log("Assessment URL:", assessmentURL);
// const assessmentURL= 'http://localhost:5000/api';
export const getAssessmentsfromAdminSearch = async ({
  searchQuery="",
  page = 1,
  limit = 10,
}) => {
  // category, searchQuery, type, difficulty,
      const token = getAccessToken();
      console.log("Token in getAssessmentsfromAdminSearch:", assessmentURL);

  try {
    const response = await axios.get(
      `${assessmentURL}/assessments?title=${searchQuery}&page=${page}&limit=${limit}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};


// get token function (adjust as per your app)
const token = getAccessToken(); 

export const getPaidAssessments = async (userId: string) => {
  try {
    const response = await axios.get(
      `${assessmentURL}/assessments/portal/getPaidAssessments/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    toast.error(`${error?.response?.data?.message}.`);
  }
};

export const getAssessmentById = async (assessmentId: string) => {
  try {
    const response = await axios.get(
      `${assessmentURL}/assessments/${assessmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error: any) {
    toast.error(`${error?.response?.data?.message}.`);
    return error;
  }
};

export const getUsers = async ({
  searchQuery,
  role,
  page = 1,
  limit = 10,
}: any) => {
  try {
    const response = await axiosInstance.get(
      `${assessmentURL}/admin/portal/getUsers?search=${searchQuery}&isActive=undefined&role=${role}&page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    toast.error(`${error?.response?.data?.message}.`);
    return error;
  }
};




export const getUsersForFranchise = async ({
  franchiseId,
  searchQuery,
  role,
  page = 1,
  limit = 10,
}: any) => {
  try {
    const response = await axios.get(
      `${assessmentURL}/admin/portal/getUsersForFranchise/${franchiseId}?search=${searchQuery}&role=${role}&page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    toast.error(`${error?.response?.data?.message}.`);
    return error;
  }
};

export const getCandidatesForAssessment = async (assessmentId : string) => {
      const token = getAccessToken();

  try {
    const response = await axiosInstance.get(
      `${assessmentURL}/admin/getCandidatesForAssessment/${assessmentId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};

export const getResultForCandidateAssessment = async (interviewId: string) => 
  {
    const token = getAccessToken();
  try {
    const response = await axiosInstance.get(
      `${assessmentURL}/admin/portal/getResultForCandidateAssessment/${interviewId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};
export const getRecording = async (interviewId: string) => {
      const token = getAccessToken();
  
  try {
    const response = await axios.get(
      `${assessmentURL}/admin/portal/getRecording/${interviewId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};

export const getTranscript = async (interviewId: string) => {
      const token = getAccessToken();
  
  try {
    const response = await axios.get(
      `${assessmentURL}/admin/portal/getTranscript/${interviewId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
  if (error instanceof AxiosError) {
    toast.error(`${error.response?.data?.message}.`);
  } else {
    // Handle other types of errors
  }
  return error;
}
};

export const getTransactionsForSprAdmin = async (page = 1, limit = 10) => {
      const token = getAccessToken();

  try {
    const response = await axiosInstance.get(`${assessmentURL}/admin/getTransactions`, {
      params: { page, limit },
       headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message || "Failed to fetch transactions";
    toast.error(`${errorMessage}.`);
    return { success: false, message: errorMessage, error };
  }
};


export const getExamResults = async (params:{page?: string, limit?: 10, search:string}) => {
  try {
    const response = await axiosInstance.get(`${assessmentURL}/exam/getallusers?search=${params.search}&page=${params.page}&limit=${params.limit}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch exam results:", error.response?.data?.message);
    throw error;
  }
};

export const getTransactionsForFranchisenAdmin = async (
  page = 1,
  limit = 10,
  franchiseId : string
) => {
      const token = getAccessToken();

  try {
    console.log("Getting transactions for BDE Referral ID:", franchiseId);
    const response = await axios.get(
      `${assessmentURL}/admin/franchise/getTransactions/${franchiseId}`,
     {
        params: { page, limit },
         headers: {
        Authorization: `Bearer ${token}`,
      },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch transactions:", error.response?.data?.message);
    const errorMessage =
      error?.response?.data?.message || "Failed to fetch transactions";
    toast.error(`${errorMessage}.`);
    return { success: false, message: errorMessage, error };
  }
};

interface IPortalUserDetails {
  id: string;
  username: string;
  email: string;
  role: string;
  franchiseId?: string;
  bdeReferralId?: string;
  isOnboarded: boolean;
  companyId?: string;
  linkedinUrl?: string;
  profilePhotoUrl?: string;
}

interface ICandidateDetails {
  id: string;
  name: string;
  email: string;
  phone: string;
}

interface IGetMeResponse {
  status: string;
  data: {
    user?: IPortalUserDetails;
    candidate?: ICandidateDetails;
  };
}

export const getCurrentUserDetails = async (): Promise<IGetMeResponse> => {
  try {
    const response = await axiosInstance.get<IGetMeResponse>('/auth/me');
    
    if (response.status !== 200) {
      throw new Error('Failed to fetch user details');
    }

    console.log("User details fetched successfully:", response.data);
    
    // Type guard to check if it's a portal user or candidate
    if (response.data.data.user) {
      return {
        status: 'success',
        data: {
          user: response.data.data.user
        }
      };
    } else if (response.data.data.candidate) {
      return {
        status: 'success',
        data: {
          candidate: response.data.data.candidate
        }
      };
    }

    throw new Error('Invalid response format');

  } catch (error: any) {
    console.error("Failed to fetch user details:", error.response?.data?.message);
    
    // Don't show toast here as this might be called frequently in auth contexts
    throw error;
  }
};

// Fetch TPO users with pagination, search, role, and blockStatus
export const getTPOUsers = async ({
  page = 1,
  limit = 10,
  search = "",
  role = "",
  blockStatus,
}: {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
  blockStatus?: string;
} = {}) => {
  try {
    const params = {
      page,
      limit,
      search,
      role,
      blockStatus,
    };
    const response = await axiosInstance.get("/users/tpos", { params });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch TPO users:", error.response?.data?.message);
    throw error;
  }
};


/**
 * Downloads applications as an Excel file from the export endpoint, with filters.
 * @param params Query params for filtering (optional)
 */


export const exportCoordinatedInterviewsExcel = async (params: Record<string, any> = {}): Promise<void> => {
  try {
    const response = await axiosInstance.get('/applications/coordinated-interviews/export', {
      params,
    });

    // Extract applications array from your response
    const applications = response.data?.data?.applications || [];

    if (!applications.length) {
      toast.error("No applications found to export.");
      return;
    }

    // Convert JSON to worksheet (append Company Name column only)
    const worksheet = XLSX.utils.json_to_sheet(
      applications.map((app: any) => ({
        ...app,
        "Company Name":
          app?.company?.name ||
          app?.job?.companyName ||
          app?.job?.company?.name ||
          app?.companyName ||
          "",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Coordinated Interviews");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'applications.xlsx');
    document.body.appendChild(link);
    link.click();

    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error("Failed to export applications:", error?.message || error?.response?.data?.message);
    toast.error(`Failed to export applications: ${error?.message || error?.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

export interface ExportApplicationsResponse {
  applications: Record<string, unknown>[];
  hasNextPage: boolean;
  nextCursor: string | null;
  totalResults: number;
}

export const fetchApplicationsExportBatch = async (
  params: Record<string, unknown> = {}
): Promise<ExportApplicationsResponse> => {
  try {
    const response = await axiosInstance.get("/applications/export", { params });
    return response.data as ExportApplicationsResponse;
  } catch (error: any) {
    toast.error(
      `Failed to export applications: ${error?.response?.data?.message || error?.message || "Unknown error"}`
    );
    throw error;
  }
};

export const exportApplicationsExcel = async (params: Record<string, any> = {}): Promise<void> => {
  try {
    const response = await fetchApplicationsExportBatch(params);
    const applications = response?.applications || [];

    if (!applications.length) {
      toast.error("No applications found to export.");
      return;
    }

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(applications);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'applications.xlsx');
    document.body.appendChild(link);
    link.click();

    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error("Failed to export applications:", error?.message || error?.response?.data?.message);
    throw error;
  }
};

// ...existing code...

/**
 * Downloads joined dashboard applications as an Excel file.
 * @param params Query params for filtering (optional)
 */
export const exportJoinedDashboardApplicationsExcel = async (params: Record<string, any> = {}): Promise<void> => {
  try {
    const response = await axiosInstance.get(
      '/applications/joined-dashboard/export',
      { params }
    );

    const applications = response.data?.data?.applications || [];

    if (!applications.length) {
      toast.error("No joined dashboard applications found to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(applications);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "JoinedDashboardApplications");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'joined_dashboard_applications.xlsx');
    document.body.appendChild(link);
    link.click();

    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error("Failed to export joined dashboard applications:", error?.message || error?.response?.data?.message);
    toast.error(`Failed to export joined dashboard applications: ${error?.message || error?.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};
// ...existing code...




